import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { CreateSpot, Spot, SpotListResponse, SpotsQueryParams, UpdateSpot } from '@frontend/spot/types';

export class SpotClient extends APIClient {
    public static readonly endpoint = '/spot-api/v1';

    static async fetchSpots(queryParams?: ApiQueryParams<SpotsQueryParams | DefaultQueryParams>, withCredentials?: Token): Promise<SpotListResponse> {
        return this.apiPaginated<SpotListResponse, DefaultQueryParams>(`${this.endpoint}/spots`, queryParams, withCredentials);
    }

    static async resolveSpots(spotIds: string[]): Promise<SpotListResponse> {
        const response = await this.post(`${this.endpoint}/spots-resolve`, { ids: spotIds });
        return await this.handleResponse<SpotListResponse>(response);
    }

    public static async deleteSpots(spotIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/spots-delete`, { ids: spotIds });
        return await this.handleVoidResponse(response);
    }

    static async postSpot(accountId: string, spot: CreateSpot): Promise<Spot> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/spots`, spot);
        return await this.handleResponse<Spot>(response);
    }

    static async fetchSpot(accountId: string, spotId: string): Promise<Spot> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}`);
        return await this.handleResponse<Spot>(response);
    }

    static async patchSpot(accountId: string, spotId: string, spot: UpdateSpot): Promise<Spot> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}`, spot);
        return await this.handleResponse<Spot>(response);
    }

    static async deleteSpot(accountId: string, spotId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/spots/${spotId}`);
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
